import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import loadings from './loadings.module.scss'
import MerchantLogo from '../../merchant/logo/merchant-logo'
import { useMerchant } from '@/src/context/merchant/merchant-context'

interface Props {
    opacity?: boolean
    showMerchantLogo?: boolean
    defaultSpinner?: boolean
}

export default function LoadingFullscreen(props: Props) {
    const getRandomLoader = () => Math.floor(Math.random() * 7) + 1
    const [currentLoader, setCurrentLoader] = useState(getRandomLoader())
    const [isTransitioning, setIsTransitioning] = useState(false)
    const { merchantSummary } = useMerchant()

    useEffect(() => {
        const changeLoader = () => {
            setIsTransitioning(true)

            setTimeout(() => {
                setCurrentLoader(prevLoader => {
                    let newLoader = getRandomLoader()
                    while (newLoader === prevLoader) {
                        newLoader = getRandomLoader()
                    }
                    return newLoader
                })
                setIsTransitioning(false)
            }, 100)
        }

        const interval = setInterval(changeLoader, 2900)
        return () => clearInterval(interval)
    }, [])

    const getLoaderClassName = () => {
        switch (currentLoader) {
            case 1: return loadings.loader1
            case 2: return loadings.loader2
            case 3: return loadings.loader3
            case 4: return loadings.loader4
            case 5: return loadings.loader5
            case 6: return loadings.loader6
            case 7: return loadings.loader7
            default: return loadings.loader1
        }
    }

    return (
        <div style={{
            backgroundColor: props.opacity === false ? 'var(--foreground-color)' : 'initial'
        }} className={styles.container}>
            {
                props.showMerchantLogo
                    ?
                    merchantSummary ? <MerchantLogo className={styles.logo} /> : <></>
                    :
                    props.defaultSpinner ? <div className={styles.loader} /> :
                        <div className={`${loadings.content} ${isTransitioning ? loadings.fadeOut : loadings.fadeIn}`}>
                            <div className={getLoaderClassName()} />
                        </div>
            }
            <div className={styles.overlay} />
        </div>
    )
}